import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { saleActions } from "../slices/sale";
import { getErrorMessage } from "../../utils/errorUtils";

import { SaleResponseDto } from "../../shared/dtos/sale/SaleResponseDto";
import { SaleSummaryDto } from "../../shared/dtos/sale/SaleSummaryDto";
import { DateRangePaginationQueryDto } from "../../shared/dtos/common/DateRangePaginationQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getSales =
  (params?: DateRangePaginationQueryDto) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(saleActions.setLoadingFetchAll());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<SaleSummaryDto>>
      >("/sales", {
        headers: { requiresAuth: true },
        params,
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(saleActions.setSales(data.data.content));
        dispatch(saleActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(saleActions.setErrorFetchAll(getErrorMessage(error)));
    }
  };

export const getSaleById =
  (id: string) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(saleActions.setLoadingFetchOne());
    try {
      const { data } = await axiosInstance.get<ApiResponseDto<SaleResponseDto>>(
        `/sales/${id}`,
        {
          headers: { requiresAuth: true },
        },
      );
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(saleActions.setSale(data.data));
      }
    } catch (error) {
      dispatch(saleActions.setErrorFetchOne(getErrorMessage(error)));
    }
  };
